export default __webpack_public_path__ + "1c6dc94494318c81139623668aa47642.svg";